export function findRef(models, refName) {
    return models.find((model) => Object.keys(model)[0] === refName) || null;
}
